var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommunityIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.176 34.086H44.825v26.753h13.352V34.086z",
    fill: "#C6C9D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.55 61.21H44.465V33.704h14.097V61.21h-.012zm-13.352-.753h12.62v-26h-12.62v26z",
    fill: "#2D344B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.781 52.237H37.26v2.59h2.521v-2.59z",
    fill: "#F0F2F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.155 55.21H36.9v-3.343h3.255v3.344zm-2.534-.752h1.788V52.62h-1.788v1.838z",
    fill: "#2D344B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.824 52.237h-2.521v2.59h2.521v-2.59z",
    fill: "#F0F2F6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.198 55.21h-3.255v-3.343h3.255v3.344zm-2.522-.752h1.789V52.62h-1.789v1.838z",
    fill: "#2D344B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.867 52.237h-2.521v2.59h2.521v-2.59z",
    fill: "#F0F2F6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.24 55.21h-3.254v-3.343h3.255v3.344zm-2.52-.752h1.788V52.62h-1.789v1.838z",
    fill: "#2D344B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.92 52.237h-2.522v2.59h2.522v-2.59z",
    fill: "#F0F2F6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.293 55.21H52.04v-3.343h3.254v3.344zm-2.521-.752h1.788V52.62h-1.788v1.838z",
    fill: "#2D344B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.781 36.704H37.26v2.59h2.521v-2.59z",
    fill: "#F0F2F6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.155 39.676H36.9v-3.344h3.255v3.344zm-2.534-.753h1.788v-1.838h-1.788v1.838z",
    fill: "#2D344B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.824 36.704h-2.521v2.59h2.521v-2.59z",
    fill: "#F0F2F6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M45.198 39.676h-3.255v-3.344h3.255v3.344zm-2.522-.753h1.789v-1.838h-1.789v1.838z",
    fill: "#2D344B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M49.865 36.704h-2.521v2.59h2.521v-2.59z",
    fill: "#F0F2F6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M50.239 39.676h-3.255v-3.344h3.255v3.344zm-2.522-.753h1.789v-1.838h-1.789v1.838z",
    fill: "#2D344B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M54.92 36.704h-2.522v2.59h2.522v-2.59z",
    fill: "#F0F2F6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M55.293 39.676H52.04v-3.344h3.254v3.344zm-2.521-.753h1.788v-1.838h-1.788v1.838z",
    fill: "#2D344B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M39.781 41.885H37.26v2.591h2.521v-2.59z",
    fill: "#F0F2F6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M40.155 44.858H36.9v-3.344h3.255v3.344zm-2.534-.753h1.788v-1.837h-1.788v1.837z",
    fill: "#2D344B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M44.824 41.885h-2.521v2.591h2.521v-2.59z",
    fill: "#F0F2F6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M45.198 44.858h-3.255v-3.344h3.255v3.344zm-2.522-.753h1.789v-1.837h-1.789v1.837z",
    fill: "#2D344B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M49.867 41.885h-2.521v2.591h2.521v-2.59z",
    fill: "#F0F2F6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M50.24 44.858h-3.254v-3.344h3.255v3.344zm-2.52-.753h1.788v-1.837h-1.789v1.837z",
    fill: "#2D344B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M54.92 41.885h-2.522v2.591h2.522v-2.59z",
    fill: "#F0F2F6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M55.293 44.858H52.04v-3.344h3.254v3.344zm-2.521-.753h1.788v-1.837h-1.788v1.837z",
    fill: "#2D344B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M39.781 47.08H37.26v2.59h2.521v-2.59z",
    fill: "#F0F2F6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M40.155 50.052H36.9v-3.357h3.255v3.357zm-2.534-.766h1.788V47.45h-1.788v1.837z",
    fill: "#2D344B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M44.824 47.08h-2.521v2.59h2.521v-2.59z",
    fill: "#F0F2F6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M45.198 50.052h-3.255v-3.357h3.255v3.357zm-2.522-.766h1.789V47.45h-1.789v1.837z",
    fill: "#2D344B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M49.867 47.08h-2.521v2.59h2.521v-2.59z",
    fill: "#F0F2F6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M50.24 50.052h-3.254v-3.357h3.255v3.357zm-2.52-.766h1.788V47.45h-1.789v1.837z",
    fill: "#2D344B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M54.92 47.08h-2.522v2.59h2.522v-2.59z",
    fill: "#F0F2F6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M55.293 50.052H52.04v-3.357h3.254v3.357zm-2.521-.766h1.788V47.45h-1.788v1.837z",
    fill: "#2D344B"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M20.628 28.433h-8.831V60.84h8.831V28.433z",
    fill: "#C6C9D5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M21.002 61.208h-9.564v-33.16H21v33.16zm-8.832-.753h8.086V28.801h-8.098v31.654h.012z",
    fill: "#2D344B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M17.586 31.52h-2.521v2.59h2.52v-2.59z",
    fill: "#F0F2F6"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M17.957 34.481h-3.254v-3.344h3.254v3.344zm-2.534-.753h1.79V31.89h-1.79v1.838z",
    fill: "#2D344B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M17.586 36.704h-2.521v2.59h2.52v-2.59z",
    fill: "#F0F2F6"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M17.957 39.676h-3.254v-3.344h3.254v3.344zm-2.534-.753h1.79v-1.838h-1.79v1.838z",
    fill: "#2D344B"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M17.586 41.886h-2.521v2.59h2.52v-2.59z",
    fill: "#F0F2F6"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M17.957 44.859h-3.254v-3.344h3.254v3.344zm-2.534-.753h1.79v-1.838h-1.79v1.838z",
    fill: "#2D344B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M17.586 47.08h-2.521v2.59h2.52v-2.59z",
    fill: "#F0F2F6"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M17.957 50.053h-3.254v-3.357h3.254v3.357zm-2.534-.766h1.79v-1.838h-1.79v1.838z",
    fill: "#2D344B"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M17.586 52.263h-2.521v2.591h2.52v-2.59z",
    fill: "#F0F2F6"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M17.957 55.237h-3.254v-3.344h3.254v3.344zm-2.534-.753h1.79v-1.838h-1.79v1.838z",
    fill: "#2D344B"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M40.291 13.215h-15.14v4.05h15.14v-4.05z",
    fill: "#576183"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M40.665 17.696H24.79v-4.897h15.874v4.897zm-15.141-.862h14.408v-3.188H25.524v3.188z",
    fill: "#2D344B"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M36.514 9.18h-7.577v4.05h7.577V9.18z",
    fill: "#2D344B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M36.875 13.647h-8.297V8.75h8.31v4.897h-.013zm-7.564-.847h6.831V9.612h-6.831V12.8z",
    fill: "#2D344B"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M44.825 17.266H20.628v43.527h24.195V17.266z",
    fill: "#9EA3B7"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M45.186 61.21H20.258V16.834h24.928v44.374zm-24.183-.848h23.45V17.697h-23.45v42.665z",
    fill: "#2D344B"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M36.514 52.263h-7.577v8.577h7.577v-8.577z",
    fill: "#F0F2F6"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M36.875 61.21h-8.297v-9.33h8.31v9.33h-.013zm-7.564-.753h6.831v-7.811h-6.831v7.811z",
    fill: "#2D344B"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M33.088 52.263h-.733v8.577h.733v-8.577zM41.559 21.77H23.897v.753h17.662v-.754zM41.559 25.662H23.897v.753h17.662v-.753zM41.559 29.555H23.897v.753h17.662v-.753zM41.559 33.448H23.897v.753h17.662v-.753zM41.559 37.329H23.897v.753h17.662v-.753zM41.559 41.222H23.897v.753h17.662v-.753zM41.559 45.113H23.897v.753h17.662v-.753zM41.559 49.007H23.897v.753h17.662v-.753zM26.492 52.899h-2.596v.753h2.596v-.753zM41.557 52.899H38.96v.753h2.596v-.753z",
    fill: "#2D344B"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M63.619 54.712v-.163l-.16-.033c-2.013-.417-3.548-2.295-3.548-4.555v-4.686c0-2.57 1.982-4.642 4.397-4.642s4.398 2.073 4.398 4.642v4.686c0 2.26-1.535 4.138-3.548 4.555l-.16.033v5.763c0 .418-.318.738-.69.738-.37 0-.69-.32-.69-.737v-5.601zM5.001 54.712v-.163l-.159-.033c-2.013-.418-3.548-2.295-3.548-4.555v-4.686c0-2.57 1.982-4.642 4.397-4.642s4.398 2.073 4.398 4.642v4.686c0 2.26-1.536 4.137-3.549 4.555l-.159.033v5.763c0 .418-.318.738-.69.738-.371 0-.69-.32-.69-.737v-5.601z",
    fill: "#9EA3B7",
    stroke: "#2D344B",
    strokeWidth: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityIcon);
export default __webpack_public_path__ + "static/media/community_icon.4b608f5631460316b17474bce1946c0e.svg";
export { ForwardRef as ReactComponent };